import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { fetchCustomers } from "../customer/api/customerApi";
import { assignMachineToCustomer, fetchMachineData } from "./api/machineApi";

const AssignMachineToCustomer = () => {
  const [customers, setCustomers] = useState([]);
  const [machines, setMachines] = useState([]);
  const [formData, setFormData] = useState({
    customerId: "",
    machineId: "",
  });
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    async function loadData() {
      try {
        const customersData = await fetchCustomers();
        const machinesData = await fetchMachineData();
        setCustomers(customersData || []);
        setMachines(machinesData || []);
      } catch (err) {
        console.error("Error loading dropdown data", err);
      }
    }
    loadData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAssign = async () => {
    if (!formData.customerId || !formData.machineId) return;

    setLoading(true);

    try {
      await assignMachineToCustomer(formData.machineId, formData.customerId);
      alert("Machine assigned successfully!");
      history.push("/machine-overview");
    } catch (error) {
      console.error("Assign error:", error);
      alert("Error assigning machine: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: "auto",
        mt: 4,
        p: 2,
        border: "1px solid #ccc",
        borderRadius: 1,
      }}
    >
      <Typography variant="h6" align="center" gutterBottom>
        Assign Machine to Customer
      </Typography>

      <FormControl fullWidth margin="normal" size="small" required>
        <InputLabel id="machine-label">Machine</InputLabel>
        <Select
          labelId="machine-label"
          id="machineId"
          name="machineId"
          value={formData.machineId}
          label="Machine"
          onChange={handleChange}
        >
          <MenuItem value="">
            <em>Select Machine</em>
          </MenuItem>
          {machines.map(({ id, machineName }) => (
            <MenuItem key={id} value={id}>
              {machineName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal" size="small" required>
        <InputLabel id="customer-label">Customer</InputLabel>
        <Select
          labelId="customer-label"
          id="customerId"
          name="customerId"
          value={formData.customerId}
          label="Customer"
          onChange={handleChange}
        >
          <MenuItem value="">
            <em>Select Customer</em>
          </MenuItem>
          {customers.map(({ id, name }) => (
            <MenuItem key={id} value={id}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button
        variant="contained"
        fullWidth
        disabled={!formData.machineId || !formData.customerId || loading}
        sx={{
          mt: 2,
          bgcolor: "#1976d2",
          color: "white",
          "&:hover": {
            bgcolor: "#1976d2",
          },
          "&.Mui-disabled": {
            bgcolor: "#1976d2 !important",
            color: "white !important",
            cursor: "not-allowed",
          },
        }}
        onClick={handleAssign}
      >
        {loading ? "Assigning..." : "Assign Machine to Customer"}
      </Button>
    </Box>
  );
};

export default AssignMachineToCustomer;
